import React, { Component } from 'react';

import { StyleSheet, View, Keyboard } from 'react-native';

import Modal from './shared/Modal';
import Button from './shared/Button';
import { TextInputLabel } from './shared/TextInput';

import { resetPassword } from '../lib/userApiCalls';

import { EMAIL_PATTERN, styles as signUpStyles } from './SignUpModal';
import appStore from '../stores/app';
import { t } from '../utils/appUtils';
import { ERRORS } from '../lib/appConstants';
import { BottomLabel } from './SignInScreen';

const styles = StyleSheet.create({
  form: { marginTop: 0, alignItems: 'center' },
});

function validate({ email }: { email: string }): string | null {
  if (!email) {
    return t('auth.emailRequired');
  }

  if (!EMAIL_PATTERN.test(email.trim())) return t('auth.emailInvalid');

  return null;
}

type Props = {
  onHide: () => void;
};

type State = {
  fields: {
    email: string;
  };
};

export default class ForgotPasswordModal extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      fields: {
        email: '',
      },
    };
  }

  onChangeInput(key: string, value: string) {
    this.setState((state) => ({
      fields: {
        ...state.fields,
        [key]: value,
      },
    }));
  }

  onSubmit = async () => {
    const { onHide } = this.props;
    const { fields } = this.state;
    let { email } = fields;
    email = email.trim();

    const validateMsg = validate({ email });

    if (validateMsg) {
      appStore.showMessage({ type: 'error', text: validateMsg });
      return;
    }

    appStore.toggleLoading(true);
    Keyboard.dismiss();
    try {
      await resetPassword(email);
    } catch (e) {
      appStore.showMessage({
        type: 'error',
        text:
          {
            [ERRORS.USER_NOT_FOUND]: t('auth.noUserToEmail'),
          }[(e as any).code] || (e as any).message,
      });
      appStore.toggleLoading(false);
      return;
    }

    appStore.toggleLoading(false);

    onHide();

    appStore.showMessage({
      type: 'success',
      delay: 4000,
      text: t('auth.emailReseted'),
    });
  };

  render() {
    const { onHide } = this.props;
    const { fields } = this.state;
    const { email } = fields;

    return (
      <Modal
        title={t('auth.forgotPassword')}
        onHide={onHide}
        {...({ closeStyle: (signUpStyles as any).close } as any)}
      >
        <View style={signUpStyles.container}>
          <View style={styles.form}>
            <TextInputLabel
              label={t('auth.email').toUpperCase()}
              value={email}
              autoCapitalize="none"
              returnKeyType="done"
              onSubmitEditing={this.onSubmit}
              onChangeText={(value: string) => this.onChangeInput('email', value)}
            />

            <Button
              style={signUpStyles.button}
              textStyle={{
                fontSize: 15,
              }}
              size="large"
              onPress={this.onSubmit}
            >
              {t('auth.reset')}
            </Button>

            <BottomLabel
              leftText={t('auth.haveRemembered')}
              rightText={t('auth.signIn')}
              onPress={onHide}
            />
          </View>
        </View>
      </Modal>
    );
  }
}
